import { Toets } from '@models/toetsen';
import { PeriodsI } from '@models/periods';

export interface ToetsenStateModel {
  toetsen: Toets[];
  isLoading: boolean;
  isLoaded: boolean;
  isSaved: boolean;
  error: string | null;
  periods: PeriodsI | null;
}

export const toetsenInitialState: ToetsenStateModel = {
  toetsen: [],
  isLoading: false,
  isLoaded: false,
  isSaved: false,
  error: null,
  periods: null,
};
